export default __webpack_public_path__ + "static/media/Snapdeal.4ace94d2.png";